import { IUserAccess } from '@/interfaces/auth/IUserAccess.ts';

export const defaultUserAccess: IUserAccess = {
    research: {
        isSubscriber: false,
        acceptedDeltaGptTerms: true,
        acceptedAiWarning: false,
        admin: false,
        isTrial: false,
        canShareTemporaryReports: false,
    },
    enact: {
        shortTermMarkets: null,
        longTermMarkets: null,
        assetTracking: null,
        residential: null,
        acceptedEnactTerms: true,
    },
    isAdmin: false,
    isAdminRequestApprover: false,
    isLcp: false,
};
